import {STANDARD_PLATE_HEIGHT} from 'App';

// Two ceowniki per plate, matching prepare_response/_normalize_plates in
// kns-excel xps_calculations/calculations.py:578-586 - there is no extra ceownik
// for a non-standard plate.
export const calculateSpanRodsAmount = ({standardPlates, nonStandardPlates, amount}) => {
  return 2 * (standardPlates + nonStandardPlates) * amount;
}

export const calculateSpanNonStandardPlates = ({elements, moduleHeight}) => {
  return elements.filter((el) => el !== STANDARD_PLATE_HEIGHT && el !== moduleHeight).length;
}

export const calculateSpanStandardPlates = ({elements}) => {
  return elements.filter((el) => el === STANDARD_PLATE_HEIGHT).length;
}
